import { WeightIndicator, WeightIndicatorMap } from 'models/weight';

export const getWeightIndicatorColor = (indicator?: WeightIndicator): string => {
  if (!indicator) return 'var(--mantine-color-gray-5)';
  return WeightIndicatorMap[indicator].color;
};
